import dayjs from "dayjs";
import React from "react";
import { connect } from "react-redux";
import { ChallanJson } from "../../DynamicFormsJson/MastersJSON/challan";
import { getStockholderByAreaIdsForFilter } from "../../Slice/StackHolder.slice";
import {
  getAreaByTalukaPostBody,
  getAreaByUserType,
} from "../../Slice/area.slice";
import { getDistrictByZone } from "../../Slice/district.slice";
import { getRegionNew } from "../../Slice/region.slice";
import { getDriversByStockHolderId } from "../../Slice/salesExecutive.slice";
import { getStateByRegion } from "../../Slice/state.slice";
import { getTalukaByDistrict } from "../../Slice/taluka.slice";
import { getVanStockTransferByDriverAndDate } from "../../Slice/vanStockTransfer.slice";
import { getZoneByState } from "../../Slice/zone.slice";
import DynamicMainScreen from "../../components/dynamicscreens/DynamicMainScreen";
import endpoint from "../../config/endpoints";
import {
  cancelledChallanMsg,
  challanCancelMsg,
  noInternetMsg,
  serverMsg,
} from "../../config/messageconstant";
import { ChallanColumns } from "../../tableColumns/table-columns";
import { apiGet } from "../../utils/api_service";
import { showLoador, showNotification } from "../Landing/Landing.slice";
class ChallanTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedAreaIds: [],
      dynamicMasterData: {
        areaDetail: this.props.areaList.area,
        regionDetail: this.props.regionList?.region,
        stateDetail: this.props.stateList?.stateByRegion,
        zoneDetail: this.props.zoneList?.zoneByState,
        districtDetail: this.props.districtList?.districtByZone,
        talukaDetail: this.props.talukaList?.talukaByDistrict,
        areaDetail: this.props.areaList?.areaByTaluka,
        stockHolderDetail: this.props.stockHolderList?.stockholderByArea,
        driverDetail: this.props.driverList?.driverByStockHolder,
      },
    };
  }

  async componentDidMount() {
    const { getRegionNew, getAreaByUserType, showLoador, showNotification } =
      this.props;
    const { adminFlag } = this.state;

    if (navigator.onLine) {
      const userTypeId = localStorage.getItem("userTypeId");

      if (userTypeId == 1 || userTypeId == 6) {
        showLoador({ loador: true });
        await getRegionNew().then(({ success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        });

        this.setState({
          adminFlag: true,
        });
      } else {
        showLoador({ loador: true });
        await getAreaByUserType().then(({ success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        });

        this.getData();
      }
    } else {
      this.props.showNotification({ msg: noInternetMsg, severity: "error" });
    }
  }

  getData = async () => {
    const { getVanStockTransferByDriverAndDate, showLoador, showNotification } =
      this.props;
    if (navigator.onLine) {
      let todaysDate = dayjs().format("DD-MM-YYYY");
      let driverIdData = {
        salesTeamIds: [],
      };
      showLoador({ loador: true });
      await getVanStockTransferByDriverAndDate({
        fromDate: todaysDate,
        toDate: todaysDate,
        driverIdJson: driverIdData,
      }).then(({ success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        }
      });
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.regionList !== nextProps.regionList) {
      if (this.props.regionList?.region !== nextProps.regionList?.region) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            regionDetail: nextProps.regionList?.region,
          },
        });
      }
    }
    if (this.props.stateList !== nextProps.stateList) {
      if (
        this.props.stateList?.stateByRegion !==
        nextProps.stateList?.stateByRegion
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            stateDetail: nextProps.stateList?.stateByRegion,
          },
        });
      }
    }
    if (this.props.zoneList !== nextProps.zoneList) {
      if (
        this.props.zoneList?.zoneByState !== nextProps.zoneList?.zoneByState
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            zoneDetail: nextProps.zoneList?.zoneByState,
          },
        });
      }
    }
    if (this.props.districtList !== nextProps.districtList) {
      if (
        this.props.districtList?.districtByZone !==
        nextProps.districtList?.districtByZone
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            districtDetail: nextProps.districtList?.districtByZone,
          },
        });
      }
    }
    if (this.props.talukaList !== nextProps.talukaList) {
      if (
        this.props.talukaList?.talukaByDistrict !==
        nextProps.talukaList?.talukaByDistrict
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            talukaDetail: nextProps.talukaList?.talukaByDistrict,
          },
        });
      }
    }
    if (this.props.areaList !== nextProps.areaList) {
      if (this.props.areaList?.area !== nextProps.areaList?.area) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            areaDetail: nextProps.areaList?.area,
          },
        });
      }
    }

    if (this.props.areaList !== nextProps.areaList) {
      if (
        this.props.areaList?.areaByTaluka !== nextProps.areaList?.areaByTaluka
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            areaDetail: nextProps.areaList?.areaByTaluka,
          },
        });
      }
    }
    if (this.props.stockHolderList !== nextProps.stockHolderList) {
      if (
        this.props.stockHolderList?.stockholderByArea !==
        nextProps.stockHolderList?.stockholderByArea
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            stockHolderDetail: nextProps.stockHolderList?.stockholderByArea,
          },
        });
      }
    }
    if (this.props.driverList !== nextProps.driverList) {
      if (
        this.props.driverList?.driverByStockHolder !==
        nextProps.driverList?.driverByStockHolder
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            driverDetail: nextProps.driverList?.driverByStockHolder,
          },
        });
      }
    }
  }

  getListById = async (data) => {
    const {
      getStateByRegion,
      getZoneByState,
      getDistrictByZone,
      getTalukaByDistrict,
      getAreaByTalukaPostBody,
      getStockholderByAreaIdsForFilter,
      getDriversByStockHolderId,
      showLoador,
      showNotification,
    } = this.props;
    const { selectedAreaIds } = this.state;
    if (navigator.onLine) {
      if (data.region && data.region != "") {
        showLoador({ loador: true });
        await getStateByRegion({ regionIds: data.region }).then(
          ({ success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            }
          }
        );
      }
      if (data.state && data.state != "") {
        showLoador({ loador: true });
        await getZoneByState({ stateIds: data.state }).then(({ success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        });
      }
      if (data.zone && data.zone != "") {
        showLoador({ loador: true });
        await getDistrictByZone({ zoneIds: data.zone }).then(({ success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        });
      }
      if (data.district && data.district != "") {
        showLoador({ loador: true });
        await getTalukaByDistrict({ districtIds: data.district }).then(
          ({ success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            }
          }
        );
      }
      if (data.taluka && data.taluka != "") {
        let talukaJson = {
          talukaIds: data.taluka,
        };
        showLoador({ loador: true });
        await getAreaByTalukaPostBody({ talukaIds: talukaJson }).then(
          ({ success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            }
          }
        );
      }

      if (this.state.adminFlag) {
        if (data.area && data.area != "") {
          this.setState({ selectedAreaIds: data.area });

          showLoador({ loador: true });
          await getStockholderByAreaIdsForFilter({ areaIds: data.area }).then(
            ({ success }) => {
              showLoador({ loador: false });
              if (!success) {
                showNotification({ msg: serverMsg, severity: "error" });
              }
            }
          );
        }

        if (data.stockHolder && data.stockHolder != "") {
          let areaIdsObj = {
            areaIds: selectedAreaIds,
          };

          showLoador({ loador: true });
          await getDriversByStockHolderId({
            stockHolderId: data.stockHolder,
            areaIdJson: areaIdsObj,
          }).then(({ success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            }
          });
        }
      } else {
        if (data.area && data.area != "") {
          let areaIdsObj = {
            areaIds: data.area,
          };

          showLoador({ loador: true });
          await getDriversByStockHolderId({
            stockHolderId: "",
            areaIdJson: areaIdsObj,
          }).then(({ success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            }
          });
        }
      }
    } else {
      this.props.showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  onSearchData = async (data) => {
    const { getVanStockTransferByDriverAndDate, showLoador, showNotification } =
      this.props;
    if (navigator.onLine) {
      if (data.driver && data.driver != "") {
        let driverIdData = {
          salesTeamIds: data.driver,
        };
        showLoador({ loador: true });
        await getVanStockTransferByDriverAndDate({
          fromDate: data.fromDate,
          toDate: data.toDate,
          driverIdJson: driverIdData,
        }).then(({ success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        });
      }
    } else {
      this.props.showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  rowCancel = (rowData) => {
    const { showLoador, showNotification } = this.props;
    const { adminFlag } = this.state;
    swal({
      title: "Are you sure?",
      text: challanCancelMsg,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        showLoador({ loador: true });
        const statusCode = 2;
        apiGet({
          url:
            endpoint.vanStockTransferHeader +
            "/update-status?vanStockTransferHeaderId=" +
            rowData.id +
            "&status=" +
            statusCode,
        }).then(({ data, success }) => {
          showLoador({ loador: false });
          if (!success) {
            this.props.showNotification({
              msg: serverMsg,
              severity: "error",
            });
          } else {
            showNotification({ msg: cancelledChallanMsg });
            if (adminFlag) {
              window.location.reload();
            } else {
              this.getData();
            }
          }
        });
      }
    });
  };

  render() {
    const { challanList } = this.props;
    const { adminFlag, dynamicMasterData } = this.state;
    return (
      <>
        <DynamicMainScreen
          dynamicMasterData={dynamicMasterData}
          onSearchData={this.onSearchData}
          getListById={this.getListById}
          searchList={
            adminFlag
              ? ChallanJson.searchListForAdmin
              : ChallanJson.searchListForStockHolder
          }
          formPath={ChallanJson.formPath}
          formPathView={ChallanJson.formPathView}
          screenTitle={ChallanJson.screenTitle}
          fieldMeta={ChallanJson.fieldMeta}
          showPdfDownload={false}
          showExcelDownload={false}
          changeExcelURL={ChallanJson.excelUrl}
          showExtension={false}
          filterDataExcel={true}
          showViewButtonInTable={true}
          pdfFileName={ChallanJson.pdfFileName}
          excelFileName={ChallanJson.excelFileName}
          showAddButton={ChallanJson.showAddButton}
          tableColumnsToFilter={ChallanJson.tableColumnsToFilter}
          tableColumns={ChallanColumns}
          tableData={challanList?.vanStockTransfer}
          getTableData={this.getData}
          callApi={false}
          getTableDataById={true}
          apiBaseURL={ChallanJson.apiBaseURL}
          baseIdColumn={ChallanJson.baseIdColumn}
          isNote={true}
          isNoteValue={"Challan"}
          showDeleteIcon={adminFlag ? false : true}
          showEditIcon={true}
          isLog={true}
          type={0}
          showCancel={adminFlag ? false : true}
          showCancelTitle="Cancel Challan"
          rowCancel={this.rowCancel}
          cancelBillConditionName="status"
          cancelBillConditionValue="0"
          deleteConditionName="status"
          deleteConditionValue="0"
          editConditionName="status"
          editConditionValue="0"
        />
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  challanList: state.vanStockTransfer,
  areaList: state.area,
  regionList: state.region,
  stateList: state.states,
  zoneList: state.zone,
  districtList: state.district,
  talukaList: state.taluka,
  stockHolderList: state.stackholder,
  driverList: state.salesExecutive,
});
const mapDispatchToProps = {
  showLoador,
  showNotification,
  getRegionNew,
  showNotification,
  showLoador,
  getRegionNew,
  getZoneByState,
  getDistrictByZone,
  getTalukaByDistrict,
  getAreaByTalukaPostBody,
  getStateByRegion,
  getStockholderByAreaIdsForFilter,
  getDriversByStockHolderId,
  getAreaByUserType,
  getVanStockTransferByDriverAndDate,
};
export default connect(mapStateToProps, mapDispatchToProps)(ChallanTable);
